export const validateZipCode = async (value: any) => {
  return await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?components=country:US%7Cpostal_code:${value}&sensor=false&key=AIzaSyDBQAIQEghquOKcM63AbhSMvgMA0g2rUQk`
  ).then(async (res) => {
    const { status } = await res.json();
    return status === 'OK';
  });
};
